import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, Send, Phone, ShieldCheck, AlertTriangle } from "lucide-react";
import { logo, contact, nav, restrictedTerritories } from "../mock";

const Footer = () => {
  return (
    <footer className="relative bg-[#05050a] border-t border-[#00ff87]/15 pt-16 pb-8 overflow-hidden">
      <div className="glow-blob w-72 h-72 bg-[#00ff87] -bottom-24 -left-16" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <img src={logo} alt="DaddyAnna" className="h-12 w-auto mb-4" />
            <p className="text-gray-400 text-sm leading-relaxed">
              India's most trusted online cricket id provider since 2015. Instant IDs, best odds and 24x7 support.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href={contact.whatsapp} target="_blank" rel="noreferrer" className="h-10 w-10 grid place-items-center rounded-lg bg-[#00ff87]/10 text-[#00ff87] hover:bg-[#00ff87] hover:text-black transition-colors">
                <MessageCircle size={18} />
              </a>
              <a href={contact.telegram} target="_blank" rel="noreferrer" className="h-10 w-10 grid place-items-center rounded-lg bg-[#00e5ff]/10 text-[#00e5ff] hover:bg-[#00e5ff] hover:text-black transition-colors">
                <Send size={18} />
              </a>
              <a href={contact.signal} target="_blank" rel="noreferrer" className="h-10 w-10 grid place-items-center rounded-lg bg-white/5 text-white hover:bg-white hover:text-black transition-colors">
                <Phone size={18} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              {nav.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-gray-400 text-sm hover:text-[#00ff87] transition-colors">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-4">Our Games</h4>
            <ul className="space-y-2.5 text-gray-400 text-sm">
              <li>Online Cricket ID</li>
              <li>Live Sports Exchange</li>
              <li>Casino & Teen Patti</li>
              <li>Aviator & Crash Games</li>
              <li>Refer & Earn</li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-4">Play Responsibly</h4>
            <div className="flex items-center gap-2 text-[#00ff87] text-sm font-semibold mb-3">
              <ShieldCheck size={16} /> 18+ Only · GST Registered
            </div>
            <p className="text-gray-500 text-xs leading-relaxed flex gap-2">
              <AlertTriangle size={26} className="text-yellow-500 shrink-0" />
              Engaging in betting may result in financial loss. Please play within your limits. This site is for entertainment for users 18+.
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5">
          <p className="text-gray-600 text-xs leading-relaxed">
            <span className="text-gray-400 font-semibold">Restricted Territories: </span>
            {restrictedTerritories.join(", ")}. Access to this site is restricted in certain geographical territories.
          </p>
        </div>

        <div className="mt-8 pt-6 border-t border-white/5 flex flex-col items-center gap-3 text-center">
          <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-sm">
            <Link to="/privacy-policy" className="text-[#f2d94e] hover:text-[#00ff87] transition-colors">Privacy Policy</Link>
            <span className="text-gray-600">|</span>
            <Link to="/responsible-gambling" className="text-[#f2d94e] hover:text-[#00ff87] transition-colors">Responsible Gambling</Link>
            <span className="text-gray-600">|</span>
            <Link to="/terms-of-services" className="text-[#f2d94e] hover:text-[#00ff87] transition-colors">Terms of Services</Link>
          </div>
          <p className="text-gray-300 text-sm">
            © {new Date().getFullYear()}. All rights reserved. Powered by <span className="text-[#00ff87] font-semibold">DaddyAnna</span>
          </p>
          <p className="text-gray-600 text-xs">Online Cricket ID · Cricket ID · DaddyAnna</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
